import React from "react"
import DataValidation from "./DataValidation"

export const DataValidationPage = () => {
	return <DataValidation />
}
